var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMore24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10104_2723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.333C10 20.433 10.9 21.333 12 21.333C13.1 21.333 14 20.433 14 19.333C14 18.233 13.1 17.333 12 17.333C10.9 17.333 10 18.233 10 19.333ZM10 4.66633C10 5.76634 10.9 6.66634 12 6.66634C13.1 6.66633 14 5.76634 14 4.66633C14 3.56633 13.1 2.66633 12 2.66633C10.9 2.66633 10 3.56633 10 4.66633ZM10 11.9997C10 13.0997 10.9 13.9997 12 13.9997C13.1 13.9997 14 13.0997 14 11.9997C14 10.8997 13.1 9.99967 12 9.99967C10.9 9.99967 10 10.8997 10 11.9997Z",
    fill: "#9FA2A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10104_2723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore24);
export default __webpack_public_path__ + "static/media/icon_more24.27330272c5f57170540b1fd3ab362ede.svg";
export { ForwardRef as ReactComponent };